import { useEffect } from "react";

/**
 * Listen for a specific key press on the window.
 * Optionally filter out events from inputs/textareas with `ignoreInputs`.
 */
export function useKey(
  key: string,
  handler: (e: KeyboardEvent) => void,
  { ignoreInputs = false }: { ignoreInputs?: boolean } = {},
) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key !== key) return;
      if (
        ignoreInputs &&
        (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement)
      )
        return;
      handler(e);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [key, handler, ignoreInputs]);
}
